import router from './router'
import { getAccessToken } from '@/utils/auth'
import { useStore } from "vuex";
import store from '@/store'
import { CACHE_KEY, useCache } from '@/store/web/useCache'
import { HttpManager } from "@/api";

const { wsCache } = useCache()


 const setUserInfoAction= async ()=> {
      if (!getAccessToken()) {
        wsCache.delete(CACHE_KEY.USER)
        return null
      }
      let userInfo = wsCache.get(CACHE_KEY.USER)
      if (!userInfo) {
        const result = (await HttpManager.getInfo()) as ResponseBody;
        userInfo = result.data
      } else {
        // 特殊：在有缓存的情况下，进行加载。但是即使加载失败，也不影响后续的操作，保证可以进入系统
        try {
          const result = (await HttpManager.getInfo()) as ResponseBody;
          userInfo = result.data
        } catch (error) {console.log(error)}
      }
      // commit("setMyInfo", userInfo);
      wsCache.set(CACHE_KEY.USER, userInfo)
      store.commit("setToken", true);
      store.commit("setMyInfo", userInfo);

      store.commit("setUserId", userInfo.id);
      store.commit("setUsername", userInfo.username);
      store.commit("setUserPic", userInfo.avator);
      // store.commit("setAccessToken", userInfo.accessToken);
      // store.commit("setRefreshToken", userInfo.refreshToken);
      // store.commit("setAccessToken", result.data.token);
      store.commit("setShowAside", true);
    }

// 路由不重定向白名单
const whiteList = [
  '/login',
  '/social-login',
  '/auth-redirect',
  '/bind',
  '/register',
  '/oauthLogin/gitee',
  '/sign-up',
  '/sign-in'
]
// 路由加载前
router.beforeEach(async (to, from, next) => {
  if (getAccessToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // const userStore = useUserStoreWithOut()
      // const permissionStore = usePermissionStoreWithOut()
      // const store = useStore()
      // store.commit("setToken", true);
      debugger
      // console.log('a1234567')
      // console.log('a1234567'+store.getters.myInfo)
      console.log('a1234567: '+store.getters.token)
      // if (store.getters.myInfo==null || store.getters.myInfo.empty()) {
      if (!store.getters.myInfo) {
      // if (!wsCache.get(CACHE_KEY.USER)) {
        // await store.dispatch('setUserInfoAction')
        await setUserInfoAction()
        const redirectPath = from.query.redirect || to.path
        // 修复跳转时不带参数的问题
        const redirect = decodeURIComponent(redirectPath as string)
        // const { paramsObject: query } = parseURL(redirect)
        // const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect, query }
        const nextData =  { ...to, replace: true }
        next(nextData)
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login`) // 否则全部重定向到登录页
      // next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    }
  }
})
